import { accessoryDrawerStateResolver } from './dashboards/accessoryDrawerStateResolver'
import { dashboardsResolver } from './dashboards/dashboardsResolver'
import { isEditingLayoutsResolver } from './dashboards/isEditingLayoutsResolver'
import { layoutsResolver } from './dashboards/layoutsResolver'
import { tempLayoutsResolver } from './dashboards/tempLayoutsResolver'

import type { QueryResolvers } from '../../../generated/graphql'

export const Query: QueryResolvers = {
    accessoryDrawerState: accessoryDrawerStateResolver,
    dashboards: dashboardsResolver,
    isEditingLayouts: isEditingLayoutsResolver,
    layouts: layoutsResolver,
    tempLayouts: tempLayoutsResolver,
}
